export class MediaManagerApiBase {}
//# sourceMappingURL=MediaManagerApiBase.js.map